import { Button, Checkbox, Form, FormInstance } from 'antd';
import { setStoredInput } from 'presentation/redux/features/CU/CU03101Slice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import React, { useEffect, useState } from 'react';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { DetailProperty } from '../models/DetailProperty';
import { CountStep } from './CountStep';
import { InputSelectOption } from './Input';

type OptionType = { value: number; name: any }[];

interface props {
    form: FormInstance<any>;
    detailProperty?: DetailProperty;
}

export const StepFive = ({ form, detailProperty }: props) => {
    const [loanOptions, setLoanOptions] = useState<{ value: number; name: number }[]>([]);
    const [yearOptions, setYearOptions] = useState<{ value: number; name: number }[]>([]);
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [gapYears, setGapYears] = useState<number>(30);
    const dispatch = useAppDispatch();
    const disabledBTN = useAppSelector((state) => state.CU03101Slice.disabledBTN);
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);

    useEffect(() => {
        generateLoanOption();
        generateOwnerYearOption();
    }, []);

    useEffect(() => {
        setUpGapYears();
        setIsChecked(form.getFieldValue('allowed'));
    }, [JSON.stringify(detailProperty)]);

    const onNext = () => {
        const ownshipYearValue = form.getFieldValue('ownshipYear');
        let isSubmit = ownshipYearValue || ownshipYearValue === 0;
        const loanBalance = form.getFieldValue('loanBalance');
        if (!loanBalance && loanBalance !== 0) {
            isSubmit = isSubmit && form.getFieldValue('allowed');
        }
        const newStoredInput = {
            ...storedInput,
            loanBalance: form.getFieldValue('loanBalance'),
            ownshipYear: form.getFieldValue('ownshipYear'),
            page: 5,
            submit: isSubmit,
            prev: false,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    const onBack = () => {
        const newStoredInput = {
            ...storedInput,
            prev: true,
            page: 5,
            submit: true,
        };
        dispatch(setStoredInput(newStoredInput));
    };

    const setUpGapYears = () => {
        const ownshipYear = form.getFieldValue('ownshipYear');
        if (ownshipYear) {
            setGapYears(ownshipYear);
        } else {
            form.setFieldValue('ownshipYear', 15);
        }
    };

    const generateLoanOption = () => {
        const optionLoan: OptionType = [];
        for (let i = 0; i <= 4000; i += 100) {
            optionLoan.push({
                value: i,
                name: i + (i === 4000 ? '万円以上' : '万円'),
            });
        }
        setLoanOptions(optionLoan);
    };

    const generateOwnerYearOption = () => {
        const optionOwnerYear: OptionType = [];
        for (let i = 0; i <= 30; i++) {
            optionOwnerYear.push({
                value: i,
                name: i + (i === 30 ? '年以上' : '年'),
            });
        }
        setYearOptions(optionOwnerYear);
    };

    const onCheckBoxChange = (event: any) => {
        if (event.target.checked) {
            form.setFieldsValue({ loanBalance: null });
        }
        setIsChecked(event.target.checked);
    };

    return (
        <React.Fragment>
            <CountStep current={5} title="残債・所有年数を入力してください。" />
            <InputSelectOption
                disabled={isChecked}
                label={<div>残債</div>}
                isRequired={!isChecked}
                requiredMessage={getMessage('Sel_Required', '残債')}
                options={loanOptions}
                name="loanBalance"
                placeholder={PLACEHOLDER.SELECT}
            />
            <section
                style={{ width: '100%', marginTop: 24 }}
                className="input-font-style label-form-style"
            >
                <Form.Item style={{ padding: 0, margin: 0 }} valuePropName="checked" name="allowed">
                    <Checkbox className="checkbox-font" onChange={onCheckBoxChange}>
                        残債不明（便宜上0円とする）
                    </Checkbox>
                </Form.Item>
            </section>
            <InputSelectOption
                label="所有年数"
                isRequired
                requiredMessage="所有年数を選択してください。"
                options={yearOptions}
                name="ownshipYear"
                placeholder={PLACEHOLDER.SELECT}
            />
            <section
                style={{
                    width: '100%',
                    justifyContent: 'space-between',
                    display: 'flex',
                    gap: 20,
                }}
            >
                <Button
                    className="button-login-text"
                    style={{
                        width: 165.5,
                        height: 56,
                        marginTop: 16,
                        color: '#28323C',
                    }}
                    onClick={() => onBack()}
                >
                    戻る
                </Button>
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: 165.5, height: 56, marginTop: 16 }}
                    onClick={() => onNext()}
                    htmlType="submit"
                >
                    次へ
                </Button>
            </section>
        </React.Fragment>
    );
};
